// extracted by mini-css-extract-plugin
export default {"root":"Bottom_root__e1Ipc","links":"Bottom_links__gBftz","img":"Bottom_img__GwXwA"};